var userInvestorRegistrationCtrl = function (restSvc, ifacsSvc, $location, $scope, iFastWebContextRootSvc, iFastConstants, noCAPTCHA, $http, $window, $analytics) {
    'ngInject';
    "use strict";
    this.analytics = $analytics;
    this.setFlags(true);
    this.constants = iFastConstants;
    this.restSvc = restSvc;
    this.ifacsSvc = ifacsSvc;
    this.location = $location;
    this.scope = $scope;
    this.iFastWebContextRootSvc = iFastWebContextRootSvc;
    this.isLoaded = false;
    this.disableSubmit = false;
    this.http = $http;
    this.window = $window;
    this.userType = "Investor";
    this.showCaptcha = !(/MSIE [1-8]\./.test(this.window.navigator.userAgent));

    if (this.showCaptcha) {
        this.isRecapSolved = false;
    }
    else {
        this.isRecapSolved = true;
    }

    this.onLoad();
};


angular.module("iFAST.login")
    .directive("ngRecap", function () {
        "use strict";
        return {
            //scope: {
            //    ngRecap: "=",
            //    ngRecapval: "="
            //},
            link: function (scope) {
                scope.$watch("ngRecap", function (value) {
                    if (value) {
                        scope.$parent.$$childHead.control.isRecapSolved = true;
                    }
                });
            }
        };

    });

userInvestorRegistrationCtrl.prototype.setFlags = function (flagStatus) {
    "use strict";
    this.isInvestorRegistrationPage = flagStatus;
    this.isYourClientIdentificationNumber = flagStatus;
    this.isYourAccountNumber = flagStatus;
    this.isYourAlternateAccountNumber = flagStatus;
    this.isYourName = flagStatus;
    this.isLastFourDigitsOfYourSIN = flagStatus;
    this.isDayAndMonthOfBirth = flagStatus;
    this.isCurrentPostalCode = flagStatus;
    this.isEnterEmailAddress = flagStatus;
    this.isConfirmEmailAddress = flagStatus;
    this.doEmailAddressAndConfirmedEmailAddressMatch = flagStatus;
    this.isBestDaytimeNumbertoReachYouAt = flagStatus;
};

angular.module("iFAST.login")
    .directive("tooltip", function () {
        "use strict";
        return {
            restrict: "A",
            link: function (scope, element) {
                $(element).hover(function () {
                    $(element).tooltip("show");
                }, function () {
                    $(element).tooltip("hide");
                });
            }
        };
    });

userInvestorRegistrationCtrl.prototype.setValid = function (field) {
    "use strict";
    switch (field) {
        case "yourClientIdentificationNumber":
            this.isYourClientIdentificationNumber = true;
            break;
        case "yourAccountNumber":
            this.isYourAccountNumber = true;
            this.isYourAlternateAccountNumber = true;
            break;
        case "yourAlternateAccountNumber":
            this.isYourAlternateAccountNumber = true;
            this.isYourAccountNumber = true;
            break;
        case "yourName":
            this.isYourName = true;
            break;
        case "lastFourDigitsOfYourSIN":
            this.isLastFourDigitsOfYourSIN = true;
            break;
        case "dayAndMonthOfBirth":
            this.isDayAndMonthOfBirth = true;
            break;
        case "currentPostalCode":
            this.isCurrentPostalCode = true;
            break;
        case "enterEmailAddress":
            this.isEnterEmailAddress = true;
            break;
        case "confirmEmailAddress":
            this.isConfirmEmailAddress = true;
            break;
        case "emailAddressAndConfirmedEmailAddressDoNotMatch":
            this.doEmailAddressAndConfirmedEmailAddressMatch = true;
            break;
        case "bestDaytimeNumbertoReachYouAt":
            this.isBestDaytimeNumbertoReachYouAt = true;
    }

    if (!this.showCaptcha) {
        this.isRecapSolved = true;
    }
};

userInvestorRegistrationCtrl.prototype.validateFormFields = function () {
    "use strict";
    var isFormDatValid = true;

    if (this.yourClientIdentificationNumber === undefined || this.yourClientIdentificationNumber.trim().length === 0) {
        this.isYourClientIdentificationNumber = false;
        isFormDatValid = false;
    }

    if ((this.yourAccountNumber === undefined || this.yourAccountNumber.trim().length === 0) &&
        (this.yourAlternateAccountNumber === undefined || this.yourAlternateAccountNumber.trim().length === 0)) {
        this.isYourAccountNumber = false;
        isFormDatValid = false;
    }

    if ((this.yourAccountNumber === undefined || this.yourAccountNumber.trim().length === 0) &&
        (this.yourAlternateAccountNumber === undefined || this.yourAlternateAccountNumber.trim().length === 0)) {
        this.isYourAlternateAccountNumber = false;
        isFormDatValid = false;
    }

    if (this.yourName === undefined || this.yourName.trim().length === 0) {
        this.isYourName = false;
        isFormDatValid = false;
    }

    if (this.lastFourDigitsOfYourSIN === undefined || this.lastFourDigitsOfYourSIN.trim().length === 0) {
        this.isLastFourDigitsOfYourSIN = false;
        isFormDatValid = false;
    }

    if (this.dayAndMonthOfBirth === undefined || this.dayAndMonthOfBirth.trim().length === 0) {
        this.isDayAndMonthOfBirth = false;
        isFormDatValid = false;
    }

    if (this.currentPostalCode === undefined || this.currentPostalCode.trim().length === 0) {
        this.isCurrentPostalCode = false;
        isFormDatValid = false;
    }

    if (this.enterEmailAddress === undefined || this.enterEmailAddress.trim().length === 0) {
        this.isEnterEmailAddress = false;
        isFormDatValid = false;
    }

    if (this.confirmEmailAddress === undefined || this.confirmEmailAddress.trim().length === 0) {
        this.isConfirmEmailAddress = false;
        isFormDatValid = false;
    }

    if (this.enterEmailAddress != undefined && this.confirmEmailAddress != undefined) {
        if (this.enterEmailAddress.trim() != this.confirmEmailAddress.trim()) {
            this.doEmailAddressAndConfirmedEmailAddressMatch = false;
            isFormDatValid = false;
        }
        else {
            this.doEmailAddressAndConfirmedEmailAddressMatch = true;
        }
    }

    if (this.bestDaytimeNumbertoReachYouAt === undefined || this.bestDaytimeNumbertoReachYouAt.trim().length === 0) {
        this.isBestDaytimeNumbertoReachYouAt = false;
        isFormDatValid = false;
    }

    //if (this.repCode === undefined || this.repCode.trim().length === 0) {
    if (this.showCaptcha) {
        if (!this.isRecapSolved) {
            this.isValidRepCode = false;
            isFormDatValid = false;
        }
    }

    if (/MSIE [1-8]\./.test(this.window.navigator.userAgent)) {
        return isFormDatValid;
    }
    else {
        return isFormDatValid && this.isRecapSolved;
    }

};


userInvestorRegistrationCtrl.prototype.getValidation = function () {
    "use strict";
    var ctrl = this;

    var messages = {
        yourClientIdentificationNumberIsEmpty: ctrl.UserSelfRegistrationSetting.yourClientIdentificationNumberIsRequired, // Your Client Identification Number is required.
        yourAccountNumberIsEmpty: ctrl.UserSelfRegistrationSetting.yourAccountNumberIsRequired, // Your Account Number is required.
        yourAlternateAccountNumberIsEmpty: ctrl.UserSelfRegistrationSetting.yourAlternateAccountNumberIsRequired, // Your Alternate Account Number is required.
        yourNameIsEmpty: ctrl.UserSelfRegistrationSetting.yourNameIsRequired, // Your Name is required.
        lastFourDigitsOfYourSINIsEmpty: ctrl.UserSelfRegistrationSetting.lastFourDigitsOfYourSINRequired, // Last four digits of your SIN is required.
        dayAndMonthOfBirthIsEmpty: ctrl.UserSelfRegistrationSetting.dayAndMonthOfBirthRequired, // Day and Month of Birth are required.
        currentPostalCodeIsEmpty: ctrl.UserSelfRegistrationSetting.currentPostalCodeIsRequired, // Current Postal Code is required.
        phoneNumbeIsEmpty: ctrl.UserSelfRegistrationSetting.phoneNumbeIsRequired, // Phone number is required.
        emailAddressIsEmpty: ctrl.UserSelfRegistrationSetting.emailAddressIsRequired, // Email Address is required.
        confirmEmailAddressIsEmpty: ctrl.UserSelfRegistrationSetting.confirmEmailAddressIsRequired, // Confirm Email Address is required.
        emailAddressAndConfirmedEmailAddressDoNotMatch: ctrl.UserSelfRegistrationSetting.emailAddressAndConfirmedEmailAddressDoNotMatch, // Email Address and Confirmed Email Address do not match.
        bestDaytimeNumbertoReachYouAtIsEmpty: ctrl.UserSelfRegistrationSetting.phoneNumbeIsRequired, // Email Address and Confirmed Email Address do not match.

        recap: ctrl.UserSelfRegistrationSetting.recapCompletionRequired //ctrl.UserSelfRegistrationSetting.emailRequired //"Recaptcha completion is required"
    };

    var isErrorShown = function (ctrl) {
        return function () {
            if (ctrl && ctrl.validation && ctrl.onSubmitClicked) {
                return (!ctrl.validateFormFields());
            }
        };
    }(this);

    var validate = function (ctrl) {
        return function () {
            return ctrl.validation.validator.validate();
        };
    }(this);

    var isValid = true;

    return {
        messages: messages,
        isErrorShown: isErrorShown,
        isValid: isValid,
        validate: validate
    };
};

userInvestorRegistrationCtrl.prototype.loadSelfRegistration = function () {
    "use strict";

    this.isInvestorRegistrationPage = true;
    this.isConfirmationPage = false;
    this.disableSubmit = false;
};


userInvestorRegistrationCtrl.prototype.resetScreen = function () {
    "use strict";

    this.loadSelfRegistration();
    this.onSubmitClicked = false;

    this.yourClientIdentificationNumber = "";
    this.yourAccountNumber = "";
    this.yourAlternateAccountNumber = "";
    this.yourName = "";
    this.lastFourDigitsOfYourSIN = "";
    this.dayAndMonthOfBirth = "";
    this.currentPostalCode = "";
    this.enterEmailAddress = "";
    this.confirmEmailAddress = "";
    this.emailAddressAndConfirmedEmailAddressDoNotMatch = "";
    this.bestDaytimeNumbertoReachYouAt = "";

    //reset recaptcha
    if (this.showCaptcha) {
        this.scope.$$childTail.$$childHead.control.reset();
        this.isRecapSolved = false;
    }
    //Reset
    this.setFlags(true);
};

userInvestorRegistrationCtrl.prototype.loadSelfConfirmation = function () {
    "use strict";

    this.isInvestorRegistrationPage = false;
    this.isConfirmationPage = true;
};


userInvestorRegistrationCtrl.prototype.onLoad = function () {
    "use strict";
    var ctrl = this;
    var clientCd = "";
    if (location.hostname.indexOf("-") === -1) {
        clientCd = location.hostname.substr(0, location.hostname.indexOf("."));
    } else {
        clientCd = location.hostname.substr(0, location.hostname.indexOf("-"));
    }

    ctrl.clientCd = clientCd;
    var clientRest = this.restSvc.query({type: "configuration", method: "retrieveClientLoginSetting"}, {"clientCd": clientCd});
    clientRest.$promise.then(this.passClientLoginSetting(this), this.fail);
};


//Only following hosts e.g. {nxg/pmo/nce}, supports user registration.
userInvestorRegistrationCtrl.prototype.isSelfRegistrationEnabled = function (controller) {
    "use strict";
    if (this.userAdminSettingMap.investorSelfRegisterClient !== undefined && this.userAdminSettingMap.investorSelfRegisterClient !== null) {
    	if (this.userAdminSettingMap.investorSelfRegisterClient.toUpperCase() === "TRUE") {
    		this.validateRegistration(controller);
        } else {
        	this.onCancel();
        }
    }
    else {
    		this.onCancel();
    }
};

userInvestorRegistrationCtrl.prototype.validateRegistration = function (controller) {
    "use strict";
    var rest = this.restSvc.query({type: "configuration", method: "retrieveUserSelfRegistrationSetting"}, {"clientCd": controller.clientCd});
    var regSettingPromise = rest.$promise.then(this.passUserSelfRegistrationSetting(this), this.fail);
    regSettingPromise.then(function () {
    	controller.validation = controller.getValidation();
    	controller.emailValidationPattern = controller.createEmailValidationPattern(controller.UserSelfRegistrationSetting.userSelfRegistrationEmailBlackList);
    	controller.isLoaded = true;
    });
};

userInvestorRegistrationCtrl.prototype.createEmailValidationPattern = function (emailBlackStr) {
    "use strict";
    var emailBlackList = (emailBlackStr)? emailBlackStr.trim().split(","):"";
    var excludePattern = "";
    //var i;
    //for (i = 0; i < emailBlackList.length; i = i + 1) {
    //    excludePattern = excludePattern + "(?!" + emailBlackList[i] + "\\.)";
    //}
    return new RegExp("([a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@" + excludePattern + "[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*)","i");
};

userInvestorRegistrationCtrl.prototype.passClientLoginSetting = function (controller) {
    "use strict";
    return function (result) {
        controller.userAdminSettingMap = result.userAdminSettingMap;
        controller.language = result.userAdminSettingMap.language || navigator.language.substr(0, navigator.language.indexOf("-"));
        controller.isSelfRegistrationEnabled(controller);
    };
};

userInvestorRegistrationCtrl.prototype.passUserSelfRegistrationSetting = function (controller) {
    "use strict";
    return function (result) {
        controller.UserSelfRegistrationSetting = result.userSelfRegistrationSettingMap;
    };

};

/*Send the request to ESB for userSelfRegistration with form data*/
userInvestorRegistrationCtrl.prototype.onSubmit = function () {
    "use strict";

    // analytics
    // track analytics
    this.analytics.eventTrack("UserSelfRegister",
        {
            "fullNameValue": this.yourName,
            "fullnameText": this.yourName,
            "fullnameFieldName": "investorYourNameFld",
            "fullnameObjectName": "UserSelfRegistrationSetting",

            "phoneValue": this.bestDaytimeNumbertoReachYouAt,
            "phoneText": this.bestDaytimeNumbertoReachYouAt,
            "phoneFieldName": "investorBestDaytimeNumberToReachYouAtFld",
            "phoneObjectName": "UserSelfRegistrationSetting",

            "currentPostalCodeValue": this.currentPostalCode,
            "currentPostalCodeText": this.currentPostalCode,
            "currentPostalCodeFieldName": "investorCurrentPostalCodeFld",
            "currentPostalCodeObjectName": "UserSelfRegistrationSetting",

            "yourClientIdentificationNumberValue": this.yourClientIdentificationNumber,
            "yourClientIdentificationNumberText": this.yourClientIdentificationNumber,
            "yourClientIdentificationNumberFieldName": "investorYourClientIdentificationNumberFld",
            "yourClientIdentificationNumberObjectName": "UserSelfRegistrationSetting",

            "userNameValue": this.userName,
            "userNameText": this.userName,
            "userNameFieldName": "userSelfRegistrationDesiredUserNameFld",
            "userNameObjectName": "UserSelfRegistrationSetting",

            "emailValue": this.enterEmailAddress,
            "emailText": this.enterEmailAddress,
            "emailFieldName": "investorEnterEmailAddressFld",
            "emailObjectName": "UserSelfRegistrationSetting",

            "lastFourDigitsOfYourSINValue": this.lastFourDigitsOfYourSIN,
            "lastFourDigitsOfYourSINText": this.lastFourDigitsOfYourSIN,
            "lastFourDigitsOfYourSINFieldName": "investorLastFourDigitsOfYourSINFld",
            "lastFourDigitsOfYourSINObjectName": "UserSelfRegistrationSetting",

            "yourAccountNumberValue": this.yourAccountNumber,
            "yourAccountNumberText": this.yourAccountNumber,
            "yourAccountNumberFieldName": "investorYourAccountNumberFld",
            "yourAccountNumberObjectName": "UserSelfRegistrationSetting",

            "yourAlternateAccountNumberValue": this.yourAlternateAccountNumber,
            "yourAlternateAccountNumberText": this.yourAlternateAccountNumber,
            "yourAlternateAccountNumberFieldName": "investorYourAlternateAccountNumberFld",
            "yourAlternateAccountNumberObjectName": "UserSelfRegistrationSetting",

            "module": "Prelogin",
            "submodule": "UserSelfRegistrationSetting"});

    this.onSubmitClicked = true;

    if (!this.validateFormFields()) {
        this.loadSelfRegistration();
        return false;
    }

    var langCd = navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage);

    langCd = langCd.substr(0, langCd.indexOf("-"));

    this.disableSubmit = true;

    if (this.userAdminSettingMap.clientVersion !== null && this.userAdminSettingMap.clientVersion !== undefined &&
        this.userAdminSettingMap.clientVersion.toUpperCase() !== "REMOTE") {
        this.ifacsSvc.userSelfRegistration({ method: "user_registration"},
            {
                "full_name": this.yourName,
                "language": langCd,
                "client_identification_number": this.yourClientIdentificationNumber,
                "account_number": this.yourAccountNumber,
                "alt_account_number": this.yourAlternateAccountNumber,
                "sin": this.lastFourDigitsOfYourSIN,
                "postal_code": this.currentPostalCode,
                "day_month_birth": this.dayAndMonthOfBirth,
                "phone": this.bestDaytimeNumbertoReachYouAt,
                "email": this.enterEmailAddress,
                "client_code": this.iFastWebContextRootSvc.clientCode,
                "client_version": this.userAdminSettingMap.clientVersion,
                "user_type": this.userType
    }).$promise.then(this.success(this));
    }
    else {
        this.ifacsSvc.userSelfRegistration({ method: "user_registration"},
            {
                "full_name": this.yourName,
                "language": langCd,
                "client_identification_number": this.yourClientIdentificationNumber,
                "account_number": this.yourAccountNumber,
                "alt_account_number": this.yourAlternateAccountNumber,
                "sin": this.lastFourDigitsOfYourSIN,
                "postal_code": this.currentPostalCode,
                "day_month_birth": this.dayAndMonthOfBirth,
                "phone": this.bestDaytimeNumbertoReachYouAt,
                "email": this.enterEmailAddress,
                "client_code": this.iFastWebContextRootSvc.clientCode,
                "user_type": this.userType
        }).$promise.then(this.success(this));
    }
};

/*Stay in the information page if not successful otherwise display confirmation page */
userInvestorRegistrationCtrl.prototype.success = function (controller) {
    "use strict";

    return function (response) {
        window.console.log("User Self Registration request is submitted.");
        var responseCode = response.code;
        window.console.log("Response from ifacs:" + responseCode);
        if ("SUCCESS" === responseCode) {
            controller.loadSelfConfirmation();
        } else {
            controller.loadSelfRegistration();
        }
    };

};


userInvestorRegistrationCtrl.prototype.register = function () {
    "use strict";
/*    if ($scope.selfRegistration1.$valid) {
        $scope.showdialog = true;
        window.console.log("Form is valid");
    }*/

    //TODO evaluate if this function is needed.
};


/*Call back the login page upon cancel*/
userInvestorRegistrationCtrl.prototype.onCancel = function () {
    "use strict";
    this.location.url("/login");
};

userInvestorRegistrationCtrl.$inject = ["restSvc", "ifacsSvc", "$location", "$scope", "iFastWebContextRootSvc", "iFastConstants", "noCAPTCHA", "$http", "$window", "$analytics"];

angular.module("iFAST.login")
    .controller("userInvestorRegistrationCtrl", userInvestorRegistrationCtrl)
    .config(["noCAPTCHAProvider", function (noCaptchaProvider) {
        "use strict";
        noCaptchaProvider.setSiteKey("6LdSzf4SAAAAAP8IbU-e3uu3HvkZHsY9X7-mmT5J");
        noCaptchaProvider.setTheme("dark");
    }]);
export default userInvestorRegistrationCtrl;


// WEBPACK FOOTER //
// ./WebContent/src/login/userInvestorRegistration-controller.js